import type { Nil } from '@pbt/pbt-ui-components'

import { ClinicStatus } from '~/api/graphql/generated/types'

export enum ClinicDisplayStatus {
  Verified = 'VERIFIED',
  Unverified = 'UNVERIFIED',
  Closed = 'CLOSED',
}

const VERIFIED_STATUSES = new Set([ClinicStatus.Active, ClinicStatus.Verified])

const CLOSED_STATUSES = new Set([ClinicStatus.Deleted, ClinicStatus.Inactive])

export const getClinicDisplayStatus = (
  status: ClinicStatus | Nil,
): ClinicDisplayStatus => {
  if (!status) {
    return ClinicDisplayStatus.Unverified
  }

  if (VERIFIED_STATUSES.has(status)) {
    return ClinicDisplayStatus.Verified
  }

  if (CLOSED_STATUSES.has(status)) {
    return ClinicDisplayStatus.Closed
  }

  return ClinicDisplayStatus.Unverified
}
